import axios from "axios";
import { BASE_URL, USER_URL } from "../constant/api";

//fetch reviews

export const FetchReviewApi = async ({id}) => {
    try {
      console.log('review id ',id);
      
      const response = await USER_URL.get(`/products/reviews/${id}/`);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log("error in fetch review", error);
      throw error;
    }
  };